// Vuex project module mutations

import {
  FILL_CURRENT_LIST,
  FILL_LIST,
} from './mutations-types';

export default {
  [FILL_CURRENT_LIST](state, payload) {
    const _state = state;
    _state.currentList.records = payload.records;
    _state.currentList.total = payload.total;
  },
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
};
